import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import iView from 'iview'
import ViewUI from 'view-design';

import './index.less'
import '@/assets/styles/index.less'
import { fetch } from './plugin/callApi'
import _ from 'lodash'

Vue.prototype.$fetch = fetch
Vue.prototype._ = _

Vue.config.productionTip = false

Vue.use(ViewUI)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
